import {
    COMMENT_CREATE_FAILURE,
    COMMENT_CREATE_REQUEST,
    COMMENT_CREATE_SUCCESS,
    COMMENT_DELETE_FAILURE,
    COMMENT_DELETE_REQUEST,
    COMMENT_DELETE_SUCCESS,
    COMMENT_TOGGLE_HIGHLIGHT,
    CommentCreateFailureAction,
    CommentCreateRequestAction,
    CommentCreateSuccessAction,
    CommentDeleteFailureAction,
    CommentDeleteRequestAction,
    CommentDeleteSuccessAction,
    COMMENTS_FETCH_FAILURE,
    COMMENTS_FETCH_REQUEST,
    COMMENTS_FETCH_SUCCESS,
    CommentsFetchFailureAction,
    CommentsFetchRequestAction,
    CommentsFetchSuccessAction,
    CommentToggleHighlightAction,
} from 'mk2/apps/blogs/containers/Comments/Comments.actions';
import { tupdate } from 'mk2/helpers/types';
import { errorMessage } from 'mk2/reducers/errorMessage';
import { loadingState, LoadingState } from 'mk2/reducers/loadingState';
import { Reducer } from 'redux';

export interface CommentsState {
    commentToBeHighlighted: number;
    ids: number[];
    loadingState: LoadingState;
    errorMessage: string;
    canAdd: boolean;
}

export const initialCommentsState: CommentsState = {
    commentToBeHighlighted: null,
    ids: [],
    loadingState: LoadingState.INIT,
    errorMessage: null,
    canAdd: true,
};

declare type CommentsReducerAction =
    CommentsFetchRequestAction
    | CommentsFetchSuccessAction
    | CommentsFetchFailureAction
    | CommentDeleteRequestAction
    | CommentDeleteSuccessAction
    | CommentDeleteFailureAction
    | CommentCreateSuccessAction
    | CommentToggleHighlightAction;

const commentsReducer: Reducer<CommentsState> = (state = initialCommentsState, action: CommentsReducerAction) => {
    switch (action.type) {
        case COMMENTS_FETCH_REQUEST:
        case COMMENTS_FETCH_FAILURE:
            return tupdate(state, {
                loadingState: loadingState(state.loadingState, action),
                errorMessage: errorMessage(state.errorMessage, action),
            });

        case COMMENTS_FETCH_SUCCESS:
            return tupdate(state, {
                ids: action.response.result,
                loadingState: loadingState(state.loadingState, action),
                errorMessage: errorMessage(state.errorMessage, action),
                canAdd: action.canAdd,
            });

        case COMMENT_DELETE_SUCCESS:
            return tupdate(state, {
                ids: state.ids.filter((id) => (id !== action.response.result)),
            });

        case COMMENT_CREATE_SUCCESS:
            return tupdate(state, {
                ids: [ ...state.ids, action.response.result ],
            });

        case COMMENT_TOGGLE_HIGHLIGHT:
            return tupdate(state, {
                commentToBeHighlighted: action.commentId,
            });

        default:
            return state;
    }
};

export interface PostsState {
    [key: string]: CommentsState;
}

declare type PostsReducerAction =
    CommentsFetchRequestAction
    | CommentsFetchSuccessAction
    | CommentsFetchFailureAction
    | CommentDeleteRequestAction
    | CommentDeleteSuccessAction
    | CommentDeleteFailureAction
    | CommentCreateRequestAction
    | CommentCreateSuccessAction
    | CommentCreateFailureAction
    | CommentToggleHighlightAction;

export const postsReducer: Reducer<PostsState> = (state: PostsState = {}, action: PostsReducerAction) => {
    switch (action.type) {
        case COMMENTS_FETCH_SUCCESS:
        case COMMENTS_FETCH_REQUEST:
        case COMMENTS_FETCH_FAILURE:
        case COMMENT_DELETE_FAILURE:
        case COMMENT_DELETE_SUCCESS:
        case COMMENT_DELETE_REQUEST:
        case COMMENT_CREATE_REQUEST:
        case COMMENT_CREATE_SUCCESS:
        case COMMENT_CREATE_FAILURE:
        case COMMENT_TOGGLE_HIGHLIGHT:
            return tupdate(state, {
                [action.key]: commentsReducer(state[action.key], action),
            });

        default:
            return state;
    }
};

export default postsReducer;
